var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.54 3.597V1h4.068v2.874c2.084.474 3.805 1.41 5.622 2.5l-2.092 3.489c-1.328-.797-2.417-1.39-3.53-1.768v6.634c2.125-.001 4.007.903 5.238 2.513 1.215 1.59 1.668 3.69 1.351 5.91-.397 2.779-2.547 4.508-4.702 5.354-.6.237-1.236.42-1.887.548V31H14.54v-1.872c-.363-.061-.72-.14-1.067-.24-3.206-.916-5.57-2.666-6.473-3.569l2.876-2.877c.45.45 2.201 1.804 4.664 2.52v-6.679a12.706 12.706 0 0 1-2.128-.757c-2.188-1.016-4.261-2.851-4.942-5.916-.34-1.531-.199-2.936.4-4.147.586-1.184 1.52-2.003 2.457-2.557 1.387-.82 2.984-1.183 4.213-1.309zm0 4.1c-.704.112-1.508.335-2.143.71-.46.273-.736.567-.88.86-.132.266-.245.705-.076 1.461.336 1.511 1.314 2.473 2.685 3.11a7.6 7.6 0 0 0 .415.177V7.698zm4.068 11.1v6.066c.136-.043.27-.09.4-.142 1.404-.55 2.051-1.364 2.163-2.143.192-1.34-.118-2.29-.555-2.863-.421-.55-1.082-.917-2.007-.917z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAud);
export default __webpack_public_path__ + "static/media/AUD.c81aa92c18ce4623841778230832b58b.svg";
export { ForwardRef as ReactComponent };